import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '../../shared/shared-imports';

export type AppVersionUpdateDialogResult = 'refresh' | 'dismiss';

@Component({
  selector: 'app-version-update-dialog',
  standalone: true,
  imports: [SHARED_IMPORTS],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app-version-update-dialog.html',
  styleUrl: './app-version-update-dialog.scss',
})
export class AppVersionUpdateDialog {
  private readonly dialogRef = inject(
    MatDialogRef<AppVersionUpdateDialog, AppVersionUpdateDialogResult>,
  );

  protected dismiss(): void {
    this.dialogRef.close('dismiss');
  }

  protected refresh(): void {
    this.dialogRef.close('refresh');
  }
}
